function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
const ModalSidebar = ({
  padded,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classNames("tui-modal-sidebar", props.className, {
      padded
    })
  }));
};
ModalSidebar.displayName = "ModalSidebar";
ModalSidebar.defaultProps = {
  className: "",
  padded: true
};
ModalSidebar.propTypes = {
  className: PropTypes.string,
  padded: PropTypes.bool
};
export default ModalSidebar;
//# sourceMappingURL=ModalSidebar.js.map